export const CLOUDINARY_UPLOAD_PRESET = 'obaxyyex'
export const CLOUDINARY_API_KEY = '579628475278557'
export const CLOUDINARY_UPLOAD_URL =
  ' https://api.cloudinary.com/v1_1/ahmedeldessouki/image/upload'
